import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel } from 'swiper/modules';
import 'swiper/css';

import { ApiCall } from '../../helper/axios';
import axios from 'axios';
import '../../assets/css/BookFlight.css'
import HwSelect from "../../component/HwSelect";
import HwDatePicker from "../../component/HwDatePicker";
import { useNavigate, useLocation } from "react-router";
import {
    ArrowRightIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CityIcon,
    PlusIcon,
    RemoveIcon,
    SearchIcon,
    SwitchIcon,
    TripIcon,
    UserIcon,
    CloseIcon,
    TimeIcon,
    UserGroupIcon,
    FlightIcon,
    FlightNewIcon,
    FlightSimpleIcon,
    FlightLatestIcon
} from '../../helper/HwIcon';
import imag1 from '../../assets/img/peaceful-and-serene-sky-background.jpg'
import imag2 from '../../assets/img/flight-banner-img.jpg'
import gridimg1 from '../../assets/img/dummy-img-grid1.png'
import hgridimg1 from '../../assets/img/mumbai-to-london.png'
import hgridimg2 from '../../assets/img/bengaluru-to-dubai.png'
import hgridimg3 from '../../assets/img/hyderabad-to-new-york.png'
import hgridimg4 from '../../assets/img/mumbai-to-switzerland.png'
import Breadcrumbs from "../Breadcrumbs";
import { useDispatch, useSelector } from "react-redux";
import { getUserRecentData } from "../../redux/slice/userSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import { calcNights, getUserToken } from "../../helper/commonFunction";

const SearchFlight = ({ queryparams, setHeaderAirportMenuShow, showLoadingAfterLoad = false, isHeaderLoading = false }) => {
    let navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [airportsData, setAirportData] = useState([]);
    const [defaultAirportList, setAirportDefaultList] = useState([]);
    const [airportList, setAirportList] = useState([]);
    const [airlineData, setAirlineData] = useState([]);
    const [defaultAirlineData, setDefaultAirlineData] = useState([]);
    const [airlineInput, setAirlineInput] = useState('');
    const [airlineSelectOption, setAirlineSelectOption] = useState('');
    const [airlineInputIsOpen, setAirlineInputIsOpen] = useState(false);
    const [airlineLoading, setAirlineLoading] = useState(false);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [multiCityMenuHide, setMultiCityMenuHide] = useState(false);
    const [tempPassengerDetails, setTempPassengerDetails] = useState(null);
    const [tempPassengerClass, setTempPassengerClass] = useState(null);
    const { userAgentData, recentSearchData, recentSearchLoader } = useSelector((state) => state.userData);
    const userToken = getUserToken();

      const [filterVisible, setFilterVisible] = useState(true);




    const [initialState, setInitialState] = useState({
        tripType: 'one-way',
        passengerClass: 'Economy',
        passengerDetails: { adult: 1, children: 0, infants: 0 },
        searchDetails: [{
            fromData: { inputValue: '', airportName: '', label: '', name: '', value: '', loading: '', menuOpen: '' },
            toData: { inputValue: '', airportName: '', label: '', name: '', value: '', loading: '', menuOpen: '' },
            startDate: '',
            returnDate: ''
        }],
        preferredAirlines: false,
        directFlights: false,
        nearByAirport: false,
        passengerModal: false
    });
    const [formSchema, setFormSchema] = useState(Yup.object({
        passengerDetails: Yup.object({
            adult: Yup.number().required('At least one passenger is required'),
            children: Yup.number().required('At least one passenger is required'),
            infants: Yup.number().test('adult-required-for-infants', `Infants can't be more than adults.`, function (value) {
                const { adult } = this.parent;
                return value <= adult;
            }),
        }).test(
            'at-least-one-passenger',
            'At least one passenger is required',
            function (value) {
                const { adult, children } = value;
                return adult >= 1 || children >= 1;
            }
        ),
        searchDetails: Yup.array().of(
            Yup.object().shape({
                fromData: Yup.object({
                    value: Yup.string().required('Origin is required.'),
                }),
                toData: Yup.object({
                    value: Yup.string().required('Destination is required.')
                        .test(
                            'not-same-as-origin',
                            'Destination cannot be the same as Origin',
                            function (value) {
                                const fromValue = this?.from?.[1]?.value?.fromData?.value;
                                return !fromValue || !value || fromValue !== value;
                            }
                        ),
                }),
                startDate: Yup.date().required('Date is required'),
                returnDate: Yup.date().when('$tripType', {
                    is: 'round-trip',
                    then: (schema) => schema.required('Return date is required'),
                    otherwise: (schema) => schema.nullable(),
                })
            })
        )
    }));

    const formik = useFormik({
        initialValues: initialState,
        validationSchema: formSchema,
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        validateOnMount: false,
        onSubmit: () => {
            flightSearchBtnFn()
        }
    });

    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: 'How do I search and book flights through the portal?',
            description: 'Use the flight search panel to enter departure, arrival, dates, and passenger count. You’ll see available GDS and LCC options with filtering and fare details. Select the flight and proceed to book using your wallet or payment method.',
        },
        {
            question: 'Can I book both domestic and international flights?',
            description: 'Yes, Dahr Tours allows agents to book domestic and international flights across multiple airlines, including LCCs and full-service carriers.',
        },
        {
            question: 'What passenger details are required to confirm a booking?',
            description: 'You’ll need the passenger’s full name (as per passport/ID), date of birth, gender, and contact details. Passport info is required for international flights.',
        },
        {
            question: 'Can I hold a flight booking without paying immediately?',
            description: 'Some airlines and GDS providers support booking on hold. If available, you’ll see the “Hold Fare” option with an expiry timer during checkout.',
        },
        {
            question: 'How do I cancel or modify a booked flight?',
            description: 'You can also cancel your ticket directly from your booking history dashboard. For any modifications to your ticket, please contact us at <a href="mailto:info@dahrb2b.com">info@dahrb2b.com</a>',
        },
        {
            question: 'How are fare rules and baggage details shown?',
            description: 'Before booking, each fare option includes fare rules, baggage limits, refundability, and change fees. Click “View Details” under any flight listing to review.',
        },
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };


    useEffect(() => {
        if (formik.values.tripType === 'multi-city') {
            if (formik.values.searchDetails?.length < 2) {
                multiCityAddCityFn()
            }
        } else {
            if (formik?.values?.searchDetails) {
                const firstEntry = formik?.values?.searchDetails?.[0];
                if (formik.values.tripType !== 'round-trip') {
                    firstEntry.returnDate = '';
                }
                formik.setFieldValue('searchDetails', [firstEntry]);
            }
        }
    }, [formik.values.tripType])


    const multiCityAddCityFn = () => {
        let prevData = [...formik.values.searchDetails];
        if (prevData.length >= 6) {
            return;
        }

        let lastData = prevData[prevData?.length - 1]
        prevData.push({
            fromData: {
                inputValue: '',
                airportName: lastData?.toData?.airportName,
                label: lastData?.toData?.label,
                name: lastData?.toData?.name,
                value: lastData?.toData?.value,
                loading: '',
                menuOpen: false
            },
            toData: { inputValue: '', airportName: '', label: '', name: '', value: '', loading: '', menuOpen: '' },
            startDate: lastData?.startDate || '',
            returnDate: ''
        })
        formik.setFieldValue('searchDetails', prevData)
    }

    useEffect(() => {
        if (airlineInput) {
            fetchAirlineData(airlineInput);
        }
    }, [airlineInput])

    useEffect(() => {
        window.scrollTo(0, 0)
        onLoadLoadAirportAirlineData();
    }, []);

    useEffect(() => {
        if (airportsData?.length) {
            const data = airportsData?.map(airport => ({
                value: airport.code,
                label: `${airport.title} - ${airport.name}`,
                name: airport.name,
                airportName: airport.title,
                restData: airport?.restData || airport
            }));
            setAirportList(data);
        } else {
            setAirportList([]);
        }
    }, [airportsData]);

    const fetchAirportData = async (value, dataIndex, updateState) => {
        if (!value || value.length < 3) {
            formik.setFieldValue(`searchDetails[${dataIndex}][${updateState}][inputValue]`, value)
            return;
        }
        formik.setFieldValue(`searchDetails[${dataIndex}][${updateState}][inputValue]`, value)
        formik.setFieldValue(`searchDetails[${dataIndex}][${updateState}][loading]`, true)
        try {
            const airportApiCall = await ApiCall('POST', '/flights/airports', { search: value }, { authorization: userToken });
            if (airportApiCall?.data?.statusCode === 200 && airportApiCall?.data?.data?.length) {
                const airport_data = airportApiCall?.data?.data;
                setAirportData(airport_data.map(airport => ({
                    code: airport.code,
                    name: airport.name,
                    title: `${airport.city} (${airport.code})`,
                    restData: airport
                })));
            }
        } catch (error) {
            console.error('Error fetching airport data:', error);
        } finally {
            formik.setFieldValue(`searchDetails[${dataIndex}][${updateState}][loading]`, false)
        }
    };


    const exchnageAirportFn = (index) => {
        let prevData = [...formik.values.searchDetails];
        let perticularIndexNewData = { ...prevData[index] };
        perticularIndexNewData.fromData = {
            ...prevData[index].toData,
            inputValue: prevData[index].fromData.inputValue,
            loading: prevData[index].fromData.loading,
            menuOpen: prevData[index].fromData.menuOpen
        };
        perticularIndexNewData.toData = {
            ...prevData[index].fromData,
            inputValue: prevData[index].toData.inputValue,
            loading: prevData[index].toData.loading,
            menuOpen: prevData[index].toData.menuOpen
        };
        prevData[index] = perticularIndexNewData;
        formik.setFieldValue('searchDetails', prevData)
    }

    const fetchAirlineData = async (query) => {
        if (!query || query.length < 2) return;
        setAirlineLoading(true);
        try {
            const airlineApiCall = await ApiCall('POST', '/flights/airlines', { search: query }, { authorization: userToken });
            if (airlineApiCall?.data?.statusCode === 200 && airlineApiCall?.data?.data?.length) {
                const airline_data = airlineApiCall?.data?.data;
                setAirlineData(airline_data?.map(airlines => ({
                    value: airlines.code,
                    label: airlines.name
                })))
            }
        } catch (error) {
            console.error('Error fetching airlines data:', error);
        } finally {
            setAirlineLoading(false);
        }
    };

    const onLoadLoadAirportAirlineData = async () => {
        try {
            const airportApiCall = await ApiCall('POST', '/flights/get-famous-airport-airlines', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }, { authorization: userToken });
            if (airportApiCall?.data?.statusCode === 200 && airportApiCall?.data?.data) {
                let airport_data = airportApiCall?.data?.data?.airportData;
                let airline_data = airportApiCall?.data?.data?.airlineData;
                if (airport_data?.length) {
                    airport_data = airport_data.map(airport => ({
                        code: airport.code,
                        name: airport.name,
                        title: `${airport.city} (${airport.code})`,
                        restData: airport
                    }));
                    setAirportData(airport_data);
                    setAirportDefaultList(airport_data?.map(airport => ({
                        value: airport.code,
                        label: `${airport.title} - ${airport.name}`,
                        name: airport.name,
                        airportName: airport.title,
                        restData: airport?.restData || airport
                    })))
                }

                if (airline_data?.length) {
                    setDefaultAirlineData(airline_data?.map(airlines => ({
                        value: airlines.code,
                        label: airlines.name
                    })))
                    setAirlineData(airline_data?.map(airlines => ({
                        value: airlines.code,
                        label: airlines.name
                    })))
                }

            }
        } catch (error) {
            console.error("Error loading airport data:", error);
        }
    };

    useEffect(() => {
        if (queryparams) {
            setInitialState({
                ...initialState,
                searchDetails: queryparams?.searchDetails,
                passengerClass: queryparams?.passengerClass,
                passengerDetails: queryparams?.passengerDetails,
                directFlights: queryparams?.directFlight !== "false",
                nearByAirport: queryparams?.nearByAirport !== "false",
                preferredAirlines: queryparams.airlineCode && queryparams.airlineCode.length > 0,
                tripType: (queryparams?.returnDate) ? 'round-trip' : (queryparams?.searchDetails?.length > 1) ? 'multi-city' : 'one-way'
            });

            if (queryparams?.searchDetails?.length > 1) {
                setMultiCityMenuHide(true);
            }

            setAirlineSelectOption(queryparams?.airlineCode)
        }
    }, [queryparams])

    const openPassengerModal = () => {
        const isOpening = !formik.values.passengerModal;
        if (isOpening) {
            // Initialize temporary state with current formik values when opening modal
            setTempPassengerDetails({ ...formik.values.passengerDetails });
            setTempPassengerClass(formik.values.passengerClass);
        }
        formik.setFieldValue('passengerModal', isOpening);
    }

    const resetSubmissionState = () => {
        if (hasSubmitted) {
            setHasSubmitted(false);
        }
    }


    const airlineOnchnageFn = (selected = '') => {
        setAirlineSelectOption(selected);
        setAirlineInput('');
    }

    const airlineMenuChangeFn = (value) => {
        setAirlineInputIsOpen(value)
    }

    const airlineInputChangeFn = (value) => {
        setAirlineInput(value)
    }

    const multiCityRemoveRowFn = (index) => {
        let prevData = [...formik.values.searchDetails];
        prevData.splice(index, 1);
        formik.setFieldValue('searchDetails', prevData)
    }

    useEffect(() => {
        if (userToken) {
            dispatch(getUserRecentData(userToken))
        }
    }, [userToken])

    const flightSearchBtnFn = (directFlight, nearbyAirport, directSearch) => {
        let prevData = [...formik.values.searchDetails];
        prevData = prevData[0];
        let startDate = new Date(prevData?.startDate);
        let returnDate;
        let formikDirectFlight = formik.values.directFlights;
        let formikNearByAirport = formik.values.nearByAirport;
        if (directSearch) {
            formikDirectFlight = directFlight;
            formikNearByAirport = nearbyAirport;
        }
        startDate = startDate.toLocaleDateString('en-CA');
        let urlParams = `?from=${prevData?.fromData?.value}&to=${prevData?.toData?.value}&dep=${startDate}&ADT=${formik.values.passengerDetails.adult}&CHD=${formik.values.passengerDetails.children}&INF=${formik.values.passengerDetails.infants}&pClass=${formik.values.passengerClass}&directFlight=${formikDirectFlight}&nearByAirport=${formikNearByAirport}`;

        if (airlineSelectOption?.length) {
            let airlineCode = airlineSelectOption?.map(code => code.value).join(',');
            urlParams += `&airlineCode=${airlineCode}`;
        }

        if (formik.values.tripType === 'round-trip') {
            returnDate = new Date(prevData?.returnDate);
            returnDate = returnDate.toLocaleDateString('en-CA');
            urlParams += `&ret=${returnDate}`;
        }

        if (formik.values.tripType !== 'multi-city') {
            let addData = {
                searchData: {
                    fromData: prevData?.fromData?.airportName?.replace(/\s+/g, ''),
                    toData: prevData?.toData?.airportName?.replace(/\s+/g, ''),
                    startDate,
                    returnDate,
                    totalPassenger: Object.values(formik.values.passengerDetails).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    passengerClass: formik.values.passengerClass,
                    urlParams: urlParams,
                }
            }
            ApiCall('POST', '/flights/add-recent-search', addData, { authorization: userToken });
            if (!queryparams) {
                navigate(`/flight/list${urlParams}`);
            } else {
                navigate(`/flight/list${urlParams}`, { state: new Date().getTime() });
            }
        } else {
            let searchFlightData = formik.values.searchDetails;
            let searchParams = `?type=combo&ADT=${formik.values.passengerDetails.adult}&CHD=${formik.values.passengerDetails.children}&INF=${formik.values.passengerDetails.infants}&pClass=${formik.values.passengerClass}&directFlight=${formikDirectFlight}&nearByAirport=${formikNearByAirport}`;
            if (airlineSelectOption?.length) {
                let airlineCode = airlineSelectOption?.map(code => code.value).join(',');
                searchParams += `&airlineCode=${airlineCode}`;
            }
            searchFlightData?.map((data, index) => {
                let startDate = new Date(data?.startDate);
                startDate = startDate.toLocaleDateString('en-CA');
                searchParams += `&from[${index}]=${data?.fromData?.value}&to[${index}]=${data?.toData?.value}&dep[${index}]=${startDate}`
            })

            /*let addData = {
                searchData: {
                    searchDetails,
                    type: "combo",
                    totalPassenger: Object.values(formik.values.passengerDetails).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
                    passengerClass: formik.values.passengerClass,
                    urlParams: searchParams,
                }
            }
            ApiCall('POST', '/flights/add-recent-search', addData, { authorization: userToken });*/

            if (!queryparams) {
                navigate(`/flight/list${searchParams}`);
            } else {
                navigate(`/flight/list${searchParams}`, { state: new Date().getTime() });
            }
        }

    }

    const getDateFormat = (date) => {
        const dateData = new Date(date);
        const day = dateData.getDate();
        const month = dateData.toLocaleString('default', { month: 'short' });

        return `${day} ${month}`;
    };


    function formatRecentDate(inputDate) {
        const date = new Date(inputDate);
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);

        // Split to extract the month and day
        const [month, day] = formattedDate.split(' ');

        return `${parseInt(day)} ${month}`;
    }

    const FlightHeaderSkeleton = () => {
        const skeleton = (w, h, radius = 6) => ({
            width: w,
            height: h,
            borderRadius: radius,
            background: "linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 37%, #f0f0f0 63%)",
            backgroundSize: "400% 100%",
            animation: "skeleton-loading 1.4s ease infinite",
        });

        return (
            <>
                {/* Animation */}
                <style>
                    {`
                    @keyframes skeleton-loading {
                        0% { background-position: 100% 50%; }
                        100% { background-position: 0 50%; }
                    }
                    `}
                </style>

                <div className="hw-widget hw-widget--flight hw-widget--flight__open">
                    <div className="hw-page--width">

                        <div className="hw-widget--card" data-src={imag1}>

                            {/* Trip type row */}
                            <div
                                className="hw-tab"
                                style={{ display: "flex", gap: "18px", marginBottom: "12px" }}
                            >
                                {["One Way", "Round Trip", "Multi City"].map((label) => (
                                    <div key={label} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <div style={skeleton("14px", "14px", 999)} />
                                        <div style={skeleton(label === "Multi City" ? "72px" : "64px", "14px", 999)} />
                                    </div>
                                ))}
                            </div>

                            <div className="hw-input--groupCol">
                                <div className="hw-input--groupColLeft">
                                    <div className="hw-input--multicityGroup">
                                        <div className="hw-row--input hw-row--inputFirst">

                                            {/* FROM - TO (FULL BLOCK) */}
                                            <div
                                                className="hw-input--input"
                                                style={{
                                                    pointerEvents: "none",
                                                    flex: 1,
                                                    ...skeleton("100%", "56px", 8),
                                                }}
                                            />
                                            <div
                                                className="hw-input--input"
                                                style={{
                                                    pointerEvents: "none",
                                                    flex: 1,
                                                    ...skeleton("100%", "56px", 8),
                                                }}
                                            />

                                            {/* DATE (FULL BLOCK) */}
                                            <div
                                                className="hw-input--input"
                                                style={{
                                                    pointerEvents: "none",
                                                    flex: 1,
                                                    ...skeleton("100%", "56px", 8),
                                                }}
                                            />

                                            {/* PAX (FULL BLOCK) */}
                                            <div
                                                className="hw-input--input"
                                                style={{
                                                    pointerEvents: "none",
                                                    flex: 1,
                                                    ...skeleton("100%", "56px", 8),
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Bottom row */}
                                    <div
                                        className="hw-row--inputCheck"
                                        style={{
                                            display: "flex",
                                            gap: "1.6rem",
                                            marginTop: "16px",
                                        }}
                                    >
                                        <div style={skeleton("160px", "32px", 999)} />
                                        <div className="d-flex" style={{ gap: "5px", alignItems: "center" }}>
                                            <div style={skeleton("24px", "24px", 2)} />
                                            <div style={skeleton("120px", "32px", 999)} />
                                        </div>
                                        <div className="d-flex" style={{ gap: "5px", alignItems: "center" }}>
                                            <div style={skeleton("24px", "24px", 2)} />
                                            <div style={skeleton("120px", "32px", 999)} />
                                        </div>
                                    </div>
                                </div>

                                {/* Search button */}
                                <button
                                    type="button"
                                    className="hw-filter--searchBtn"
                                    disabled
                                    style={{
                                        pointerEvents: "none",
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                    }}
                                >
                                    <div style={skeleton("100%", "56px", 8)} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    if (isHeaderLoading) {
        return <FlightHeaderSkeleton />;
    }

    return (
        <>
            {/* {!queryparams && <Breadcrumbs/>} */}
            {(!queryparams) ?
                <div className="hw-top--fixImg"><img src={imag2} alt="" /></div>
                : ""}
            <div onClick={() => {
                // Reset temporary state when clicking outside (cancel changes)
                if (formik.values.passengerModal) {
                    setTempPassengerDetails({ ...formik.values.passengerDetails });
                    setTempPassengerClass(formik.values.passengerClass);
                }
                formik.setFieldValue('passengerModal', false);
            }} className={`hw-widget hw-widget--flight  ${queryparams ? "hw-widget--flight__open" : ""} ${filterVisible ? "" : "filter-visible"}`}>
                <div className="hw-page--width">
                    <div className={`hw-widget--card `} data-src={imag1}>
                        {!queryparams && <h1 className="hw-blue h2 mb-3">Book a Flight</h1>}
                        <div className="hw-tripType--row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1.6rem", flexWrap: "wrap", marginBottom: "1.2rem" }}>
                            <TripTypeButtons tripType={formik.values.tripType} formik={formik} resetSubmissionState={resetSubmissionState}  setFilterVisible={setFilterVisible} />
                            <div className='hw-row--inputCheck' style={{ display: "flex", gap: "1.6rem", alignItems: "center", marginTop: 0 }}>
                                <div className="hw-inputCheck--airline">
                                    <div>
                                        <div className="hw-inputCheck--airline__js hw-blue hw-fontBold hw-text14" onClick={() => {
                                            formik.setFieldValue('preferredAirlines', !formik.values.preferredAirlines)
                                        }}>Select Preferred Airlines {formik.values.preferredAirlines ? <ChevronUpIcon /> :
                                            <ChevronDownIcon />} </div>
                                    </div>
                                    {formik.values.preferredAirlines ? <div className="dropdown-container">
                                        <HwSelect
                                            placeholder='Select Airlines'
                                            options={airlineInput ? airlineData : defaultAirlineData}
                                            onChangeFn={airlineOnchnageFn}
                                            value={airlineSelectOption}
                                            menuChnageFn={airlineMenuChangeFn}
                                            onInputChangeFn={airlineInputChangeFn}
                                            loading={airlineLoading}
                                            inputValue={airlineInput}
                                            menuOpen={airlineInputIsOpen}
                                            isMulti={true}
                                            type={'airline'}
                                            inlineMenu={true}
                                            width={'100%'}
                                        />
                                    </div> : null}

                                </div>
                                <label className="hw-blue hw-fontBold hw-text14" style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.8rem",
                                    color: queryparams ? "#fff" : "",
                                    pointerEvents: showLoadingAfterLoad ? "none" : "auto",
                                }}>
                                    <input type="checkbox"
                                        checked={formik.values.directFlights}
                                        value={formik.values.directFlights}
                                        onChange={(e) => {
                                            resetSubmissionState();
                                            formik.setFieldValue('directFlights', e.target.checked)
                                            if (location.pathname === '/flight/list') {
                                                // same as Add Nearby Airports: only update the URL param so the
                                                // listing filters the flights it already has instead of re-searching
                                                const params = new URLSearchParams(location.search);
                                                params.set('directFlight', e.target.checked ? 'true' : 'false');
                                                navigate(`/flight/list?${params.toString()}`, { replace: true, state: location.state });
                                            }
                                        }}
                                    />
                                    Direct Flights
                                </label>
                                <label className="hw-blue hw-fontBold hw-text14" style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.8rem",
                                    color: queryparams ? "#fff" : "",
                                    pointerEvents: showLoadingAfterLoad ? "none" : "auto",
                                }}>
                                    <input type="checkbox"
                                        checked={formik.values.nearByAirport}
                                        value={formik.values.nearByAirport}
                                        onChange={(e) => {
                                            resetSubmissionState();
                                            formik.setFieldValue('nearByAirport', e.target.checked);
                                            if (location.pathname === '/flight/list') {
                                                const params = new URLSearchParams(location.search);
                                                params.set('nearByAirport', e.target.checked ? 'true' : 'false');
                                                navigate(`/flight/list?${params.toString()}`, { replace: true, state: location.state });
                                            }
                                        }}
                                    />
                                    Add Nearby Airports
                                </label>

                            </div>
                        </div>
                        {/* {queryparams && <div className="hw-widget--flight-close">
                            <button onClick={() => {
                                setHeaderAirportMenuShow(false)
                            }}><CloseIcon /></button>
                        </div>} */}
                        <div className="hw-input--groupCol">
                            <div className="hw-input--groupColLeft">
                                <div className="paasenger-modal">
                                    {/* commrmtntn */}
                                    {formik.values.passengerModal &&
                                        <div onClick={(e) => e.stopPropagation()} className="DT--card-container">
                                            <div className="DT--section">


                                                {Object.keys(tempPassengerDetails || formik.values.passengerDetails).map((type) => {
                                                    const label = type === 'adult' ? 'Adults ' : type === 'children' ? 'Children ' : 'Infants ';
                                                    const ageRange = type === 'adult' ? '12+ yrs' : type === 'children' ? '2-12 yrs' : 'Below 2 yrs';
                                                    const currentValue = tempPassengerDetails ? tempPassengerDetails[type] : formik.values.passengerDetails[type];

                                                    const updateCount = (change) => {
                                                        resetSubmissionState();
                                                        let newValue = currentValue + change;
                                                        // For adults, minimum is 1, for others minimum is 0
                                                        const minValue = type === 'adult' ? 1 : 0;
                                                        newValue = Math.max(minValue, Math.min(8, newValue));

                                                        // Update temporary state
                                                        setTempPassengerDetails(prev => ({
                                                            ...prev,
                                                            [type]: newValue
                                                        }));
                                                    };

                                                    return (
                                                        <div className="DT--passenger-item" key={type}>
                                                            <div className="DT--passenger-info">
                                                                <div className="DT--passenger-label"><b>{label}</b> ({ageRange})</div>

                                                            </div>
                                                            <div className="DT--counter">
                                                                <button onClick={() => updateCount(-1)}>-</button>
                                                                <div className="DT--counter-display">
                                                                    <div className="DT--counter-value">{currentValue}</div>
                                                                </div>
                                                                <button onClick={() => updateCount(1)}>+</button>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>


                                            <div className="DT--class-selector">
                                                <div className="DT--title">Travel Class</div>
                                                <div className="DT-field--checkboxGroup">
                                                    <div onClick={() => {
                                                        resetSubmissionState();
                                                        setTempPassengerClass('Economy');
                                                    }} className="DT--class-item">
                                                        <input onChange={() => {
                                                            resetSubmissionState();
                                                            setTempPassengerClass('Economy');
                                                        }} type="radio" id="input-economy" name="class"
                                                            checked={(tempPassengerClass || formik.values.passengerClass) === 'Economy'} />
                                                        <label form="input-economy" className="DT--class-label">Economy</label>
                                                    </div>
                                                    <div onClick={() => {
                                                        resetSubmissionState();
                                                        setTempPassengerClass('Premium Economy');
                                                    }} className="DT--class-item">
                                                        <input onChange={() => {
                                                            resetSubmissionState();
                                                            setTempPassengerClass('Premium Economy');
                                                        }} type="radio" id="input-premium-economy" name="class"
                                                            checked={(tempPassengerClass || formik.values.passengerClass) === 'Premium Economy'} />
                                                        <label form="input-premium-economy" className="DT--class-label">Premium
                                                            Economy</label>
                                                    </div>
                                                    <div onClick={() => {
                                                        resetSubmissionState();
                                                        setTempPassengerClass('Business');
                                                    }} className="DT--class-item">
                                                        <input onChange={() => {
                                                            resetSubmissionState();
                                                            setTempPassengerClass('Business');
                                                        }} type="radio" id="input-business" name="class"
                                                            checked={(tempPassengerClass || formik.values.passengerClass) === 'Business'} />
                                                        <label form="input-business"
                                                            className="DT--class-label">Business</label>
                                                    </div>

                                                    <div onClick={() => {
                                                        resetSubmissionState();
                                                        setTempPassengerClass('First');
                                                    }} className="DT--class-item">
                                                        <input onChange={() => {
                                                            resetSubmissionState();
                                                            setTempPassengerClass('First');
                                                        }} type="radio" id="input-first" name="class"
                                                            checked={(tempPassengerClass || formik.values.passengerClass) === 'First'} />
                                                        <label form="input-first" className="DT--class-label">First Class</label>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="DT--divider" />
                                            <div className="DT--button-selector">
                                                <button
                                                    onClick={() => {
                                                        // Reset temporary state to original formik values
                                                        setTempPassengerDetails({ ...formik.values.passengerDetails });
                                                        setTempPassengerClass(formik.values.passengerClass);
                                                        formik.setFieldValue('passengerModal', false);
                                                    }}
                                                    className="hw-btn hw-blue">Cancel</button>
                                                <button
                                                    onClick={() => {
                                                        // Apply temporary values to formik when Done is clicked
                                                        if (tempPassengerDetails) {
                                                            formik.setFieldValue('passengerDetails', tempPassengerDetails);
                                                        }
                                                        if (tempPassengerClass !== null) {
                                                            formik.setFieldValue('passengerClass', tempPassengerClass);
                                                        }
                                                        formik.setFieldValue('passengerModal', false);
                                                    }}
                                                    className="hw-btn hw-btn--primary">Done</button>
                                            </div>

                                        </div>
                                    }
                                </div>
                                <div className='hw-input--multicityGroup'>

                                    {formik.values.searchDetails?.length && formik.values.searchDetails?.map((fromToData, fromToIndex) => {
                                        if ((formik.values.tripType === "one-way" || formik.values.tripType === "round-trip")) {
                                            if (fromToIndex === 0) {
                                                return (
                                                    <>
                                                        <AirportSearchComponent
                                                            fromToData={fromToData}
                                                            fromToIndex={fromToIndex}
                                                            airportList={airportList}
                                                            defaultAirportList={defaultAirportList}
                                                            fetchAirportData={fetchAirportData}
                                                            tripType={formik.values.tripType}
                                                            multiCityRemoveRowFn={multiCityRemoveRowFn}
                                                            multiCityAddCityFn={multiCityAddCityFn}
                                                            openPassengerModal={openPassengerModal}
                                                            passengerDetails={formik.values.passengerDetails}
                                                            passengerClass={formik.values.passengerClass}
                                                            exchnageAirportFn={exchnageAirportFn}
                                                            showPassengerModal={formik.values.passengerModal}
                                                            formik={formik}
                                                            queryparams={queryparams}
                                                            hasSubmitted={hasSubmitted}
                                                            resetSubmissionState={resetSubmissionState}
                                                            location={location}
                                                            multiCityMenuHide={multiCityMenuHide}
                                                            setMultiCityMenuHide={setMultiCityMenuHide}
                                                        />
                                                    </>
                                                )
                                            }
                                        } else {
                                            return (

                                                <>
                                                    <AirportSearchComponent
                                                        fromToData={fromToData}
                                                        fromToIndex={fromToIndex}
                                                        airportList={airportList}
                                                        defaultAirportList={defaultAirportList}
                                                        fetchAirportData={fetchAirportData}
                                                        tripType={formik.values.tripType}
                                                        multiCityRemoveRowFn={multiCityRemoveRowFn}
                                                        multiCityAddCityFn={multiCityAddCityFn}
                                                        openPassengerModal={openPassengerModal}
                                                        passengerDetails={formik.values.passengerDetails}
                                                        passengerClass={formik.values.passengerClass}
                                                        exchnageAirportFn={exchnageAirportFn}
                                                        showPassengerModal={formik.values.passengerModal}
                                                        formik={formik}
                                                        queryparams={queryparams}
                                                        hasSubmitted={hasSubmitted}
                                                        resetSubmissionState={resetSubmissionState}
                                                        location={location}
                                                        multiCityMenuHide={multiCityMenuHide}
                                                        setMultiCityMenuHide={setMultiCityMenuHide}
                                                    />
                                                </>
                                            )
                                        }
                                    })}
                                </div>
                            </div>
                            <button style={{ pointerEvents: showLoadingAfterLoad && 'none' }} className='hw-filter--searchBtn' onClick={() => {
                                setHasSubmitted(true);
                                formik.validateForm().then((errors) => {
                                    if (Object.keys(errors).length === 0) {
                                        flightSearchBtnFn();
                                    }
                                });
                            }} type="button">
                                Search
                            </button>

                        </div>
                    </div>
                         {/* {queryparams &&
                             <div className="hw-page--width hw-position--relative"><button
                                className="js-show--topFilter"
                                onClick={(e) => { e.stopPropagation(); setFilterVisible(v => !v); }}
                            >
                                {filterVisible ? "Hide" : "Show"}
                                {filterVisible ? <ChevronUpIcon /> : <ChevronDownIcon />}
                            </button></div>
                            } */}
                </div>

                {(!queryparams && recentSearchData?.length) ?
                    <>
                        <div className="hw-recent--viewed pt-48">
                            <div className="hw-page--width">
                                <div className="hw-box--gridWhite">
                                    <h3 className="h3 mb-0 hw-black900">Recently Viewed Flights</h3>
                                    <Swiper
                                        className="hw-recent--viewedList"
                                        style={{ display: 'block', overflow: 'hidden' }}
                                        spaceBetween={24}
                                        slidesPerView="auto"
                                        mousewheel={{
                                            enabled: true,
                                            sensitivity: 0.5
                                        }}
                                        // mousewheel={{ releaseOnEdges: true }}
                                        modules={[Mousewheel]}
                                    >
                                        {recentSearchData?.map((recentSearch, i) => {
                                            if (recentSearch?.type !== 'combo') {
                                                return (
                                                    <SwiperSlide style={{ width: "auto" }} key={i} onClick={() => { navigate(`/flight/list${recentSearch?.urlParams}`) }}>
                                                        <div className="d-flex flex-wrap justify-between align-items-center hw-gapy10">
                                                            <span className="hw-light--badgeBlue hw-light--badgesmall">{recentSearch?.returnDate ? 'Round trip' : 'Single trip'}</span>
                                                            <span className="hw-light--badgeBlue hw-light--badgesmall"><UserGroupIcon />{recentSearch?.totalPassenger} Travellers</span>
                                                        </div>
                                                        <div className="hw-recent--middle">
                                                            {recentSearch?.type !== 'combo' ? <span className="hw-blue hw-fontBold d-flex justify-between align-items-center hw-recent--middleText"><span>{recentSearch?.fromData?.replace(/\(.*$/, '')}</span><span className="hw-recent--middleIcon"><hr /><span className="svg-wrapper"><FlightLatestIcon /></span></span><span>{recentSearch?.toData?.replace(/\(.*$/, '')}</span></span> :
                                                                recentSearch?.searchDetails?.length ? recentSearch?.searchDetails?.map((searchData) => {
                                                                    return (
                                                                        <>
                                                                            <div className="hw-recent--innerList">
                                                                                <span className="hw-blue hw-fontBold d-flex justify-between align-items-center hw-recent--middleText"><span>{searchData?.fromData?.replace(/\(.*$/, '')}</span><span className="hw-recent--middleIcon"><hr /><span className="svg-wrapper"><FlightLatestIcon /></span></span><span>{searchData?.toData?.replace(/\(.*$/, '')}</span></span>
                                                                                <div className="flex-shrink--null hw-grayk500 hw-text14">{searchData?.startDate ? formatRecentDate(searchData?.startDate) : ''} </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }) : ''
                                                            }
                                                        </div>
                                                        {recentSearch?.type !== 'combo' ? <div className="hw-grayk500 hw-text14">{recentSearch?.startDate ? formatRecentDate(recentSearch?.startDate) : ''} {recentSearch?.returnDate ? `- ${formatRecentDate(recentSearch?.returnDate)}` : ''}</div> : ''}

                                                    </SwiperSlide>
                                                )
                                            }
                                        })}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </>
                    : ''
                }
                {(!queryparams) ?
                    <>
                        {userAgentData?.top_flight_deals && userAgentData?.top_flight_deals?.length && (
                            <div className="hw-top--flights pt-48">
                                <div className="hw-page--width">
                                    <div className="hw-box--gridWhite">
                                        <div className="hw-head--textWrap">
                                            <h2 className="h3 hw-black900">Top Flight Deals Near You</h2>
                                            <p className="hw-body-alt hw-text18">Discover unbeatable prices on international routes</p>
                                        </div>

                                        <div className="hw-horizontal--grid hw-horizontal--grid4 hw-mobile--scroller">
                                            {userAgentData?.top_flight_deals?.map((flightData) => {
                                                let startDate = flightData?.onward_flight_date;
                                                let endDate = flightData?.return_flight_date;
                                                if (!startDate) {
                                                    const today = new Date();
                                                    startDate = today.toISOString().split('T')[0];
                                                }

                                                if (!endDate && flightData?.trip_type === 'round') {
                                                    const today = new Date();
                                                    today.setMonth(today.getMonth() + 3);
                                                    endDate = today.toISOString().split('T')[0];
                                                }
                                                let urlParams = `?from=${flightData?.departure_airport_code}&to=${flightData?.arrival_airport_code}&dep=${startDate}&ADT=1&CHD=0&INF=0&pClass=ECONOMY&directFlight=false&nearByAirport=false`;
                                                if (flightData?.trip_type === 'round') {
                                                    urlParams += `&ret=${endDate}`;
                                                }

                                                if (flightData) {
                                                    return (
                                                        <div className="hw-horizontal--card hw-hover--scale hw-position--relative">
                                                            <div className="hw-img--aspect1 hw-hover--scaleImg">
                                                                <img width={280} height={280} src={flightData?.deal_image} alt={flightData?.departure_airport_name || flightData?.arrival_airport_name} />
                                                            </div>
                                                            <div className="mt-16">
                                                                <div className="d-flex align-items-center hw-gapy4 hw-black900">
                                                                    <span className="hw-text18 hw-fontBold">{`${flightData?.departure_airport_name} to ${flightData?.arrival_airport_name}`}</span>
                                                                </div>
                                                                <div className="d-flex align-items-center hw-gapy8 mt-1">
                                                                    <span className="">{flightData?.trip_type === 'oneway' ? getDateFormat(startDate) : flightData?.trip_type === 'round' ? `${getDateFormat(startDate)} - ${getDateFormat(endDate)}` : getDateFormat(startDate)}</span>
                                                                    <span className="">|</span>
                                                                    <span className="">{flightData?.trip_type === 'oneway' ? 'Oneway Trip' : flightData?.trip_type === 'round' ? 'Round Trip' : 'Oneway Trip'}</span>
                                                                </div>
                                                            </div>
                                                            <a onClick={() => {
                                                                navigate(`/flight/list${urlParams}`);
                                                            }} className="hw-wholeBox--link" />
                                                        </div>
                                                    )
                                                }
                                            })}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {userAgentData?.most_booked_flights && userAgentData?.most_booked_flights?.length && (
                            <>
                                <div className="hw-most--bookedFlights pt-48">
                                    <div className="hw-page--width">
                                        <div className="hw-box--gridWhite">
                                            <div className="hw-head--textWrap">
                                                <h2 className="h3 hw-black900">Most-Booked Flights</h2>
                                                <p className="hw-body-alt hw-text18">Browse city-to-city connections loved by frequent flyers</p>
                                            </div>
                                            <div className="hw-vertical--grid hw-vertical--grid3 hw-mobile--scroller">
                                                {userAgentData?.most_booked_flights?.map((bookingData) => {
                                                    if (bookingData) {
                                                        return (
                                                            <div className="hw-vertical--card hw-hover--scale hw-position--relative">
                                                                <div className="hw-img--aspect1 hw-hover--scaleImg">
                                                                    <img width={100} height={100} src={bookingData?.flight_image} alt={bookingData?.arrival_city_name || bookingData?.departure_city_name} />
                                                                </div>
                                                                <div className="hw-text--hiddenL d-flex align-items-center hw-black900">
                                                                    <span className="hw-text18 hw-fontBold hw-text--hidden">{bookingData?.departure_city_name}</span><ArrowRightIcon />
                                                                    <span className="hw-text18 hw-fontBold hw-text--hidden">{bookingData?.arrival_city_name}</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}


                        <div className="hw-top--flights pt-48">
                            <div className="hw-page--width">
                                <div className="hw-box--gridWhite">
                                    <div className="hw-head--textWrap">
                                        <h2 className="h3 hw-black900">Flight Booking FAQs</h2>
                                    </div>

                                    <div className="hw-flight--faq">
                                        {faqs.map((faq, index) => (
                                            <div className="hw-faq--item" key={index}>
                                                <div className="hw-faq--title"
                                                    onClick={() => toggleAccordion(index)}
                                                    style={{ color: activeIndex === index ? 'var(--hw-brand-blue)' : 'var(--hw-black-900)', }}
                                                >
                                                    <span>{index + 1}.&nbsp;&nbsp;{faq.question}</span>
                                                    <span className="svg-wrapper">
                                                        {activeIndex === index ? (<ChevronUpIcon />) : (<ChevronDownIcon />)}

                                                    </span>
                                                </div>
                                                {activeIndex === index && (
                                                    <div className="hw-faq--desc">
                                                        <p dangerouslySetInnerHTML={{ __html: faq.description }} />
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </> : ''
                }




            </div>
        </>


    );
};

const AirportSearchComponent = ({
    fromToData,
    fromToIndex,
    airportList,
    defaultAirportList,
    fetchAirportData,
    tripType,
    multiCityRemoveRowFn,
    multiCityAddCityFn,
    openPassengerModal,
    passengerDetails,
    passengerClass,
    exchnageAirportFn,
    showPassengerModal,
    formik,
    queryparams,
    hasSubmitted,
    resetSubmissionState,
    location,
    multiCityMenuHide,
    setMultiCityMenuHide
}) => {
    const { fromData, toData, startDate, returnDate } = fromToData;
    let showMenu = true;
    let multiCityLabel = '';
    const isDatePickerDisabled = () => {
        if (tripType !== 'multi-city') return false;
        if (fromToIndex === 0) return false;
        const previousSegment = formik.values.searchDetails[fromToIndex - 1];
        return !previousSegment?.startDate;
    };

    const getMinDate = () => {
        if (tripType !== 'multi-city' || fromToIndex === 0) {
            return new Date();
        }
        const previousSegment = formik.values.searchDetails[fromToIndex - 1];
        return previousSegment?.startDate ? new Date(previousSegment.startDate) : new Date();
    };

    if (location.pathname === '/flight/list' && tripType === 'multi-city') {
        if (multiCityMenuHide) {
            showMenu = false;
        }
        multiCityLabel = formik.values.searchDetails?.map((values) => (values?.fromData?.cityName && values?.toData?.cityName) ? `${values?.fromData?.cityName} To ${values?.toData?.cityName}` : '')?.join(', ') || '';
    }

    const datePickerRef = useRef();

    return (
        <>
            {(tripType === 'multi-city' && (fromToIndex === 0) && location.pathname === '/flight/list') &&
                <div className='hw-row--input hw-row--inputFirst'>
                    <div onClick={() => {
                        setMultiCityMenuHide(!multiCityMenuHide)
                    }} className="hw-multiCity--field hw-input--input">
                        <FlightLatestIcon />
                        <div className="">
                            <span className="hw-text--hidden hw-blue hw-fontBold">From</span>
                            <span className="hw-text--hidden hw-gray650 hw-text14">{multiCityLabel}</span>
                        </div>
                    </div>
                    <div style={{ border: (hasSubmitted && (formik.errors.passengerDetails || formik.errors.passengerDetails?.['infants'])) && '1px red solid', position: "relative" }} className={`hw-input--input ${showPassengerModal ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); openPassengerModal(); }}>
                        <UserGroupIcon />
                        {
                            Object.values(passengerDetails || {}).reduce((acc, val) => acc + val, 0) === 0 &&
                            <span className="hw-text--hidden hw-blue hw-fontWeight--500 grid-rowspan2">
                                Travellers & class
                            </span>
                        }

                        {
                            Object.values(passengerDetails || {}).reduce((acc, val) => acc + val, 0) > 0 &&
                            <div className="grid-rowspan2 hw-gapx4">
                                <span className="hw-text--hidden hw-blue hw-fontBold hw-line--height1">
                                    {Object.values(passengerDetails || {}).reduce((acc, val) => acc + val, 0)} PAX
                                </span>
                                <span className="hw-text--hidden hw-passenger--getValue hw-line--height1">
                                    {passengerClass}
                                </span>
                            </div>
                        }
                        <div className="hw-icon--fixRight"><ChevronDownIcon /></div>
                    </div>
                </div>
            }
            {showMenu &&
                <>
                    <div className='hw-row--input hw-row--inputFirst'>

                        <div className='hw-input--switchGroup'>
                            <HwSelect
                                placeholder='From'
                                options={fromData?.inputValue ? airportList : defaultAirportList}
                                onChangeFn={(selected) => {
                                    resetSubmissionState();
                                    formik.setFieldValue(`searchDetails[${fromToIndex}][fromData]`, {
                                        inputValue: '',
                                        cityName: selected?.restData?.city || '',
                                        airportName: selected?.airportName,
                                        label: selected?.label,
                                        name: selected?.name,
                                        value: selected?.value,
                                        loading: fromData?.loading,
                                        menuOpen: fromData?.menuOpen,
                                    })
                                }}
                                value={fromData?.label ? {
                                    ...fromData, label: <div className="d-flex d-flex-column s2 hw-row--gap4">
                                        <span className="hw-black900 hw-fontWeight--500 hw-line--height1">{fromData?.cityName}</span>
                                        <span className="hw-gray650 hw-text14 hw-fontNormal hw-text--hidden hw-line--height1">{`${fromData?.value}, ${fromData?.name}`}</span>
                                    </div>
                                } : ''}
                                menuChnageFn={(value) => {
                                    formik.setFieldValue(`searchDetails[${fromToIndex}][fromData][menuOpen]`, value)
                                }}
                                onInputChangeFn={(value) => {
                                    fetchAirportData(value, fromToIndex, 'fromData')
                                }}
                                loading={fromData?.loading}
                                inputValue={fromData?.inputValue}
                                menuOpen={fromData?.menuOpen}
                                isMulti={false}
                                type={'airport'}
                                isError={hasSubmitted && formik.errors.searchDetails?.[fromToIndex]?.fromData?.value}
                            />
                            {hasSubmitted && formik.errors.searchDetails?.[fromToIndex]?.fromData?.value && <span className="hw-input--error-search left" >{formik.errors.searchDetails?.[fromToIndex]?.fromData?.value}</span>}
                            <span onClick={() => {
                                exchnageAirportFn(fromToIndex)
                            }} className='hw-switch'><SwitchIcon /></span>
                            <HwSelect
                                placeholder='To'
                                options={toData?.inputValue ? airportList : defaultAirportList}
                                onChangeFn={(selected) => {
                                    resetSubmissionState();
                                    console.log(selected, 'selected')
                                    formik.setFieldValue(`searchDetails[${fromToIndex}][toData]`, {
                                        inputValue: '',
                                        cityName: selected?.restData?.city || '',
                                        airportName: selected?.airportName,
                                        label: selected?.label,
                                        name: selected?.name,
                                        value: selected?.value,
                                        loading: toData?.loading,
                                        menuOpen: toData?.menuOpen,
                                    })
                                }}
                                value={toData?.label ? {
                                    ...toData, label: <div className="d-flex d-flex-column s3 hw-row--gap4">
                                        <span className="hw-black900 hw-fontWeight--500 hw-line--height1">{toData?.cityName}</span>
                                        <span className="hw-gray650 hw-text14 hw-fontNormal hw-text--hidden hw-line--height1">{`${toData?.value}, ${toData?.name}`}</span>
                                    </div>
                                } : ''}
                                menuChnageFn={(value) => {
                                    formik.setFieldValue(`searchDetails[${fromToIndex}][toData][menuOpen]`, value)
                                }}
                                onInputChangeFn={(value) => {
                                    fetchAirportData(value, fromToIndex, 'toData')
                                }}
                                loading={toData?.loading}
                                inputValue={toData?.inputValue}
                                menuOpen={toData?.menuOpen}
                                isMulti={false}
                                type={'airport'}
                                isError={hasSubmitted && formik.errors.searchDetails?.[fromToIndex]?.toData?.value}
                            />
                            {hasSubmitted && formik.errors.searchDetails?.[fromToIndex]?.toData?.value && <span className="hw-input--error-search right" >{formik.errors.searchDetails?.[fromToIndex]?.toData?.value}</span>}
                        </div>
                        <HwDatePicker
                            ref={datePickerRef}
                            wrapperClassName="hw-date-range-picker"
                            monthsShown={2}
                            selectDate={startDate}
                            showPreviousMonths={false}
                            onChangeFn={(date) => {
                                resetSubmissionState();
                                if (tripType === 'multi-city') {
                                    if (Array.isArray(date)) {
                                        formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, date[0]);
                                        formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, '');
                                        if (date[0]) datePickerRef.current.setOpen(false);
                                    } else {
                                        formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, date);
                                        formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, '');
                                        if (date) datePickerRef.current.setOpen(false);
                                    }
                                } else {
                                    if (formik.values.tripType === 'round-trip') {
                                        // Round-trip expects a range
                                        if (Array.isArray(date)) {
                                            if (date[0] && date[1]) {
                                                formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, date[0]);
                                                formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, date[1]);
                                                datePickerRef.current.setOpen(false);
                                            } else if (date[0] && !date[1]) {
                                                formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, date[0]);
                                                formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, '');
                                                // keep open to select return date
                                            } else if (!date[0] && !date[1]) {
                                                formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, '');
                                                formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, '');
                                            }
                                        } else if (date) {
                                            // If single date provided, set start and keep open for return
                                            formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, date);
                                            formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, '');
                                        } else {
                                            formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, '');
                                            formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, '');
                                        }
                                    } else {
                                        // One-way: single date only
                                        const selectedDate = Array.isArray(date) ? date[0] : date;
                                        if (selectedDate) {
                                            formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, selectedDate);
                                            formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, '');
                                            datePickerRef.current.setOpen(false);
                                        } else {
                                            formik.setFieldValue(`searchDetails[${fromToIndex}][startDate]`, '');
                                            formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, '');
                                        }
                                    }
                                }
                            }}
                            selectsRange={tripType === 'round-trip'}
                            type="Travel Date"
                            minDate={getMinDate()}
                            disabled={isDatePickerDisabled()}
                            startDate={formik.values.searchDetails?.[fromToIndex]?.startDate}
                            endDate={formik.values.searchDetails?.[fromToIndex]?.returnDate}
                            renderType='flight'
                            // isClearable={true}
                            isError={hasSubmitted && (formik.errors.searchDetails?.[fromToIndex]?.startDate || formik.errors.searchDetails?.[fromToIndex]?.returnDate)}
                        />
                        {(tripType === 'multi-city' && (formik.values.searchDetails?.length === fromToIndex + 1)) &&
                            <div className="hw-filter--actionBtn">
                                {formik.values.searchDetails?.length < 6 &&
                                    <button className="hw-btn hw-btn--secondaryOutline" onClick={multiCityAddCityFn}>
                                        <PlusIcon />Add Another City
                                    </button>
                                }
                                {formik.values.searchDetails?.length > 2 &&
                                    <button className="hw-btn hw-btn--grayOutline" onClick={() => {
                                        multiCityRemoveRowFn(fromToIndex)
                                    }}><RemoveIcon /></button>
                                }

                            </div>
                        }
                        {/*<HwDatePicker
                    selectDate={returnDate}
                    onChangeFn={(date) => {
                        formik.setFieldValue(`searchDetails[${fromToIndex}][returnDate]`, date)
                    }}
                    type="Return"
                    disabled={tripType === 'one-way' || tripType === 'multi-city'}
                    minDate={startDate}
                    isError={formik.errors.searchDetails?.[fromToIndex]?.returnDate}
                />*/}

                        {/* {fromToIndex === 0 &&
                    <div style={{ border: (formik.errors.passengerDetails || formik.errors.passengerDetails?.['infants']) && '1px red solid', position: "relative" }} className={`hw-input--input ${showPassengerModal ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); openPassengerModal(); }}>
                        <UserGroupIcon />
                        <span className="hw-text--hidden hw-blue hw-fontWeight--500">Travellers and class</span>
                        <span className="hw-text--hidden hw-passenger--getValue">{Object.values(passengerDetails).reduce((accumulator, currentValue) => accumulator + currentValue, 0)} PAX | {passengerClass}</span>
                        {(formik.errors?.passengerDetails || formik.errors.passengerDetails?.['infants']) && <span className="hw-input--error-search right" >{formik.errors.passengerDetails?.['infants'] ? formik.errors.passengerDetails?.['infants'] : formik.errors.passengerDetails}</span>}
                    </div>
                } */}
                        {(fromToIndex === 0 && (tripType !== 'multi-city' || location.pathname.includes('/flight/search'))) &&
                            <div style={{ border: (hasSubmitted && (formik.errors.passengerDetails || formik.errors.passengerDetails?.['infants'])) && '1px red solid', position: "relative" }} className={`hw-input--input ${showPassengerModal ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); openPassengerModal(); }}>
                                <UserGroupIcon />
                                {
                                    Object.values(passengerDetails || {}).reduce((acc, val) => acc + val, 0) === 0 &&
                                    <span className="hw-text--hidden hw-blue hw-fontWeight--500 grid-rowspan2">
                                        Travellers & class
                                    </span>
                                }

                                {
                                    Object.values(passengerDetails || {}).reduce((acc, val) => acc + val, 0) > 0 &&
                                    <div className="grid-rowspan2 hw-gapx4">
                                        <span className="hw-text--hidden hw-blue hw-fontBold hw-line--height1">
                                            {Object.values(passengerDetails || {}).reduce((acc, val) => acc + val, 0)} PAX
                                        </span>
                                        <span className="hw-text--hidden hw-passenger--getValue hw-line--height1">
                                            {passengerClass}
                                        </span>
                                    </div>
                                }
                                {hasSubmitted && (formik.errors?.passengerDetails || formik.errors.passengerDetails?.['infants']) &&
                                    <span className="hw-input--error-search left">
                                        {formik.errors.passengerDetails?.['infants'] || formik.errors.passengerDetails}
                                    </span>
                                }
                                <div className="hw-icon--fixRight"><ChevronDownIcon /></div>
                            </div>
                        }
                    </div>
                </>
            }
        </>
    )
}


const TripTypeButtons = ({ tripType, formik, resetSubmissionState, setFilterVisible  }) => {



    return (
        <div className="hw-tab">
            {["one-way", "round-trip", "multi-city"].map((type) => (
                <button
                    key={type}
                    onClick={() => {
                        resetSubmissionState();
                        formik.setFieldValue('tripType', type);
                        setFilterVisible(true);
                    }}
                    className={`trip-type-button ${tripType === type ? 'active' : ''}`}
                >
                    {/* Show the corresponding icon for each trip type */}
                    {type.replace("-", " ")}
                </button>
            ))}
        </div>
    );
};


export default SearchFlight;